document.querySelectorAll(`[id^="booking-button-"]`).forEach((bookingButton) =>
    bookingButton.addEventListener("click", () => {
        Booking.Open();
    })
);
